import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    card1: {
      paddingBottom: '8px',
      background: 'none',
    },
    fieldRow: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '10px',
    },
    activeDefHeaderGrid: {
      minHeight: '72px',
      background: 'rgba(255,255,255,0.05)',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      padding: '12px 12px 0 12px',
      fontSize: '20px',
      fontWeight: 100,
    },
    activeDefContentGrid: {
      background: 'rgba(255,255,255,0.05)',
      padding: 12,
      fontSize: '16px',
      fontWeight: 500,
      marginBottom: 2,
    },
    arrowRight: {
      height: '24px',
      width: '24px',
    },
    activeDefoldValueGrid: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    activeDeficienctField: {
      paddingRight: '10px',
      overflowWrap: 'break-word',
    },
    activeDefHeaderAlignRight: {
      textAlign: 'end',
    },
    activeDefTableCellAlignRight: {
      textAlign: 'end',
    },
    activeDeficiencyActions: {
      padding: '10px 12px',
      background: 'rgba(255,255,255,0.05)',
    },
    activeDefUserNameField: {
      textAlign: 'end',
    },
    activeDeficiencyRemovalGrid: {
      background: 'rgba(255,255,255,0.05)',
    },
    activeDefRemovalGrid: {
      padding: 12,
      fontSize: '16px',
      fontWeight: 500,
    },
    electricalActiveDef: {
      textAlign: 'end',
      paddingRight: 17,
    },
  }),
);

export default useStyles;
